Object.defineProperty(exports, "__esModule", {
  value: true
});
var b = require("/app/node_modules/koa-rpc-call/browser");
var o = exports['default'] = {};
o["strings"] = b.createRpcProxy("I18nApi", "strings", {
  "urlPrefix": "/rpc",
  httpMethod: 'GET'
});